"use client"
import { useSelectedLayoutSegments } from "next/navigation";
import RecordsStickyNav from "@/components/records/records-sticky-nav/records-sticky-nav";

export default function RecordsLayout({ children }) {
  const segments = useSelectedLayoutSegments();
  const isFeaturedPage = segments.length < 1;

  return (
    <>
      {children}
      {isFeaturedPage && <RecordsStickyNav />}
    </>
  )
}